/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { AccountEmailOtpVerifyResponse, AccountEmailOtpVerifyVars } from '../openapi-types.gen.js';

export type { AccountEmailOtpVerifyResponse, AccountEmailOtpVerifyVars } from '../openapi-types.gen.js';

export const useAccountEmailOtpVerify = createMutationHook<AccountEmailOtpVerifyVars, AccountEmailOtpVerifyResponse, unknown>({
  specName: 'useAccountEmailOtpVerify',
  path: '/v1/me/email/otp/verify',
  method: 'POST',
  resolveUrl: (vars: AccountEmailOtpVerifyVars) => `/v1/me/email/otp/verify`,
  buildBody: (vars: AccountEmailOtpVerifyVars) => ({ email: vars.email, code: vars.code }),
  parseResponse: (raw: unknown): AccountEmailOtpVerifyResponse => raw as AccountEmailOtpVerifyResponse,
  
  
  
});
